<template>
    <UFieldGroup>
        <slot v-for="term in terms" :key="term.value" :term="term">
            <UButton
                class="w-full justify-center"
                :disabled="term.disabled"
                :active="term.selected"
                active-variant="solid"
                variant="soft"
                :data-col="term.label"
                @click="term.onClick"
            >
                {{ term.label }}
            </UButton>
        </slot>
    </UFieldGroup>
</template>
<script setup lang="ts">

import {DateRange} from '@/dateUtils/DateRange'
import {useTermMatrix} from '@/dateUtils/v2/useTermMatrix'

const range = defineModel<DateRange>({required: true})
const props = defineProps<{
    isDisabled?: (range: DateRange) => boolean
}>()

const {terms} = useTermMatrix(range, props.isDisabled)

</script>

<style scoped>

</style>